/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2017,2019. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * Returns a unique identifier for the supplied component instance.
 *
 *
 * Attempts to re-use an existing unique ID (e.g. `component-unique-id`)
 * as much as possible.  If no such unique ID exists, it will generate a
 * UUID to use for the component instance.
 *
 * @param {React.Component} component The React component to compute a unique
 *                                    identifier for.
 * @returns {String} A unique identifier for the supplied component.
 */
var index = 0;
export function uniqueIdForComponent() {
  index += 1;
  return "component-unique-id-".concat(index);
}
export default uniqueIdForComponent;